import { render, staticRenderFns } from "./settings-menu-item.component.vue?vue&type=template&id=32ffb393&scoped=true"
import script from "./settings-menu-item.component.vue?vue&type=script&lang=ts&setup=true"
export * from "./settings-menu-item.component.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./settings-menu-item.component.vue?vue&type=style&index=0&id=32ffb393&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ffb393",
  null
  
)

export default component.exports